import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { FornecedorService } from '../services/fornecedor.service'
import Swal from 'sweetalert2';


@Component({
	selector: 'app-fornecedores-edit',
	templateUrl: './fornecedores-edit.component.html',
	styleUrls: ['./fornecedores-edit.component.css'],
	animations: [loadingFade]
})
export class FornecedoresEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public fornecedor_id = null;
	public href: string = "";
	public hiddenSubmit = false;

	public formFornecedor: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private Fornecedorvc: FornecedorService,
				private router: Router) { }

	ngOnInit() {


        this.href = this.router.url;
        let path = this.router.url;	
		let pathS = path.split("/"); 

		if(pathS[3] == "ver"){
			this.criaFormDisabled();
			this.hiddenSubmit = true;
		}else{
			this.criaForm();
		}

		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.fornecedor_id = params.id;
				// pega dados a partir do id
				this.Fornecedorvc.getFornecedoresEdit(params.id).then((data: any) => {
					this.preencheForm({
						fornecedor_id: data.fornecedor_id,
						fornecedor_nome: data.fornecedor_nome,
                        fornecedor_descricao: data.fornecedor_descricao,
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formFornecedor = this.fb.group({
			fornecedor_id: null,
			fornecedor_nome: ['', Validators.required],
            fornecedor_descricao: null
		});
	}

	criaFormDisabled() {
		this.formFornecedor = this.fb.group({
			fornecedor_id: null,
			fornecedor_nome: {value: null, disabled: true},
            fornecedor_descricao: {value: null, disabled: true},
		});
	}

	preencheForm(dados) {
		this.formFornecedor.setValue(dados);
	}

	enviaFornecedor() {
		if (this.formFornecedor.valid) {
			this.submitting = true;

			let toSend = this.formFornecedor.value;

			console.log("toSend", toSend);
			if (this.fornecedor_id === null) { // criar
				this.Fornecedorvc.criaFornecedores(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Fornecedor com sucesso!',
						onClose: () => {
							this.router.navigate(['home/fornecedores']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.Fornecedorvc.editaFornecedores(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Grupo alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/fornecedores']);
						}
					  });
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
					  type: 'error',
					  title: 'Ops! Algo de errado aconteceu!',
					  text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formFornecedor.controls){
				let campo = this.formFornecedor.get(field);
				campo.markAsTouched();
			}
     		this.submitting = false;
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text:'Verifique os campos obrigatórios e tente novamente.'

			});
		}
	}

	invalid(nome) {
		let input = this.formFornecedor.get(nome);
		return input.touched && input.invalid;
	}
}
